import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import KPIComparator from "components/visuals/KPIComparator";
import numberFormatter from 'utils/numberFormatter';
import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/areaHealth/marketCategorySpend";

const LargestSpendPerHead = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const largestSpendPerHead = useSelector(state => selectors.largestSpendPerHead(state));
    const { loading, error, value, percentageDifference } = largestSpendPerHead;
    const valueFormatted = numberFormatter.toGBP(value, 1);
    const label = `Catchment area yearly spend across the selected categories for ${selectedStore.name} vs ${selectedComparator.name}`;
    return (
        <Box width="100%" height="100%" data-cy="largest-spend-per-head">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default LargestSpendPerHead;
